module.exports = __webpack_public_path__ + "static/media/24-speaker_profile.926ae8fd.webp";